import React from 'react';

import { HOUR_HEIGHT, HOUR_WIDTH } from './helpers/constants';

const Item = ({ absStartHour, absEndHour, startDate, endDate, color, name, location, description, row, expectedCategory, category, selectItem }) => (
  <div
    className={'sc__timeline__track__item' + ((expectedCategory === 'All Categories' || category === expectedCategory) ? '' : ' hidden')}
    onClick={() => selectItem({
      name, location, startDate, endDate, color, description
    })}
    style={{
      width: (absEndHour - absStartHour) * HOUR_WIDTH,
      left: absStartHour * HOUR_WIDTH,
      top: row * HOUR_HEIGHT
    }}
    >
      <h4 style={{minWidth: HOUR_WIDTH}}>{ name }</h4>
      <div className="sc__timeline__track__item__bar" style={{background: color}}>
        <div className="sc__timeline__track__item__bar__start" style={{background: color}}></div>
        <div className="sc__timeline__track__item__bar__end" style={{background: color}}></div>
      </div>
  </div>
);

const Track = ({ name, rows, expectedCategory, selectItem }) => (
  <div className="sc__timeline__track" style={{height: rows.length * HOUR_HEIGHT}}>
    { rows.map((row, idx) => 
      <React.Fragment key={idx}>
        {row.map(item => <Item key={item.absStartHour + item.name} selectItem={selectItem} {...item} expectedCategory={expectedCategory} row={idx} />)}
      </React.Fragment>
    )}
  </div>
);
export default Track;


// WEBPACK FOOTER //
// ./src/components/Schedule/ScheduleComponent/Track.jsx